import { render, staticRenderFns } from "./NewMarkSpeaking.vue?vue&type=template&id=7003958e&scoped=true"
import script from "./NewMarkSpeaking.vue?vue&type=script&lang=js"
export * from "./NewMarkSpeaking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7003958e",
  null
  
)

export default component.exports